import { useMemo } from "react";
import { TransactionColumn } from "@common/types/views/transactionViews";
import { useTransactionViewConfig } from "@components/transactions/views/useTransactionViewConfig";

// A 180px control plus the 16px cell padding on each side.
const CONTROL_COLUMN_SIZE = { minSize: 212, maxSize: 212 };

/**
 * The shared transactions table config for the accrual review task. Memo is
 * headed "Memo (optional)" because confirming a row never needs one; Memo and
 * the ledger keep the fixed control width of the task design, and the action
 * column has no header label and ends at the row's edge.
 */
export const useAccrualReviewTaskViewConfig = () => {
    const transactionsViewConfig = useTransactionViewConfig();

    return useMemo((): typeof transactionsViewConfig => {
        const { columns } = transactionsViewConfig;
        return {
            ...transactionsViewConfig,
            columns: {
                ...columns,
                [TransactionColumn.NOTE]: {
                    ...columns[TransactionColumn.NOTE],
                    header: "Memo (optional)",
                    ...CONTROL_COLUMN_SIZE,
                },
                [TransactionColumn.ACCRUAL_REVIEW_LEDGER]: {
                    ...columns[TransactionColumn.ACCRUAL_REVIEW_LEDGER],
                    header: "Accrual ledger",
                    ...CONTROL_COLUMN_SIZE,
                },
                [TransactionColumn.ACCRUAL_ACTIONS]: {
                    ...columns[TransactionColumn.ACCRUAL_ACTIONS],
                    header: "",
                    align: "right",
                },
            },
        };
    }, [transactionsViewConfig]);
};
